import { BaseLog, BaseLogArgs } from './BaseLog';
import { LEVEL } from './LEVEL';

export function XhrLog({ message, data = {}, stacktrace, level = LEVEL.INFO }: Partial<BaseLogArgs>) {
    return BaseLog({
        category: 'XHR',
        message,
        data,
        level,
        stacktrace
    });
}
